/** Project number in a Firebase appId (`1:{projectNumber}:{platform}:{hash}`). */
export function projectNumberFromAppId(appId?: string): string | undefined {
  const match = appId?.trim().match(/^1:(\d+):/);
  return match?.[1];
}

/**
 * Sender ID do FCM é o project number. Se o env tiver outro valor (ex.: client ID
 * OAuth), o getToken falha depois do PWA já ter concedido a permissão nativa.
 */
export function resolveMessagingSenderId(appId?: string, senderId?: string): string | undefined {
  const fromApp = projectNumberFromAppId(appId);
  const trimmed = senderId?.trim();
  if (fromApp && trimmed && fromApp !== trimmed) {
    return fromApp;
  }
  return trimmed || fromApp;
}
